const WalletIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 14.25C15.5 13.8358 15.8358 13.5 16.25 13.5H18.25C18.6642 13.5 19 13.8358 19 14.25C19 14.6642 18.6642 15 18.25 15H16.25C15.8358 15 15.5 14.6642 15.5 14.25ZM3 5.5H3.01373C3.13809 4.37501 4.09186 3.5 5.25 3.5H16.75C17.9926 3.5 19 4.50736 19 5.75V6.58697C20.4333 6.92555 21.5 8.21321 21.5 9.75V18.25C21.5 20.0449 20.0449 21.5 18.25 21.5H6.25C4.45508 21.5 3 20.0449 3 18.25V5.5ZM18.25 8H4.5V18.25C4.5 19.2165 5.2835 20 6.25 20H18.25C19.2165 20 20 19.2165 20 18.25V9.75C20 8.7835 19.2165 8 18.25 8ZM17.5 6.5V5.75C17.5 5.33579 17.1642 5 16.75 5H5.25C4.83579 5 4.5 5.33579 4.5 5.75C4.5 6.16421 4.83579 6.5 5.25 6.5H17.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default WalletIcon;
